import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    logindisclaimer: {
      height: '10%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      padding: '29px 29px 0px 29px',
      textAlign: 'left',
    },
    root: {
      letterSpacing: '0px',
      color: '#4A4A4A',
    },
    bold: {
      fontWeight: '550',
      letterSpacing: '0px',
      color: '#4A4A4A',
    },
  }),
  { index: 1 },
)

export { useStyles }
